import { useQuery } from '@tanstack/react-query';

import { getActivityTimers } from '../../../api/activities/activityTimersApi';

export function useActivityTimers(
  activityInstanceId: number,
  enabled: boolean
) {
  return useQuery({
    queryKey: ['activity', 'timers', activityInstanceId],
    queryFn: () => getActivityTimers(activityInstanceId),
    enabled: enabled && !!activityInstanceId,
    staleTime: 10_000,
    refetchOnWindowFocus: true,
  });
}
